
/**
 * @sveltech/routify 1.9.5
 * File generated Thu Sep 03 2020 11:06:28 GMT-0600 (Central Standard Time)
 */

export const __version = "1.9.5"
export const __timestamp = "2020-09-03T17:06:28.419Z"

//buildRoutes
import { buildClientTree } from "@sveltech/routify/runtime/buildRoutes"

//imports
import __slug from '../../../../src/pages/[slug].svelte'
import _about from '../../../../src/pages/about.svelte'
import _comoFunciona from '../../../../src/pages/como-funciona.svelte'
import _index from '../../../../src/pages/index.svelte'
import _politicaEntregas from '../../../../src/pages/politica-entregas.svelte'
import _tiendas from '../../../../src/pages/tiendas.svelte'
import _ubicaciones from '../../../../src/pages/ubicaciones.svelte'

//options
export const options = {}

//tree
export const _tree = {
  "name": "root",
  "filepath": "/",
  "root": true,
  "ownMeta": {},
  "absolutePath": "src/pages",
  "children": [
    {
      "isFile": true,
      "isDir": false,
      "file": "[slug].svelte",
      "filepath": "/[slug].svelte",
      "name": "[slug]",
      "ext": "svelte",
      "badExt": false,
      "absolutePath": "/Users/osanchez/Documents/UnigoApp/src/pages/[slug].svelte",
      "importPath": "../../../../src/pages/[slug].svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/:slug",
      "id": "__slug",
      "component": () => __slug
    },
    {
      "isFile": true,
      "isDir": false,
      "file": "about.svelte",
      "filepath": "/about.svelte",
      "name": "about",
      "ext": "svelte",
      "badExt": false,
      "absolutePath": "/Users/osanchez/Documents/UnigoApp/src/pages/about.svelte",
      "importPath": "../../../../src/pages/about.svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/about",
      "id": "_about",
      "component": () => _about
    },
    {
      "isFile": true,
      "isDir": false,
      "file": "como-funciona.svelte",
      "filepath": "/como-funciona.svelte",
      "name": "como-funciona",
      "ext": "svelte",
      "badExt": false,
      "absolutePath": "/Users/osanchez/Documents/UnigoApp/src/pages/como-funciona.svelte",
      "importPath": "../../../../src/pages/como-funciona.svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/como-funciona",
      "id": "_comoFunciona",
      "component": () => _comoFunciona
    },
    {
      "isFile": true,
      "isDir": false,
      "file": "index.svelte",
      "filepath": "/index.svelte",
      "name": "index",
      "ext": "svelte",
      "badExt": false,
      "absolutePath": "/Users/osanchez/Documents/UnigoApp/src/pages/index.svelte",
      "importPath": "../../../../src/pages/index.svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": true,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/index",
      "id": "_index",
      "component": () => _index
    },
    {
      "isFile": true,
      "isDir": false,
      "file": "politica-entregas.svelte",
      "filepath": "/politica-entregas.svelte",
      "name": "politica-entregas",
      "ext": "svelte",
      "badExt": false,
      "absolutePath": "/Users/osanchez/Documents/UnigoApp/src/pages/politica-entregas.svelte",
      "importPath": "../../../../src/pages/politica-entregas.svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/politica-entregas",
      "id": "_politicaEntregas",
      "component": () => _politicaEntregas
    },
    {
      "isFile": true,
      "isDir": false,
      "file": "tiendas.svelte",
      "filepath": "/tiendas.svelte",
      "name": "tiendas",
      "ext": "svelte",
      "badExt": false,
      "absolutePath": "/Users/osanchez/Documents/UnigoApp/src/pages/tiendas.svelte",
      "importPath": "../../../../src/pages/tiendas.svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/tiendas",
      "id": "_tiendas",
      "component": () => _tiendas
    },
    {
      "isFile": true,
      "isDir": false,
      "file": "ubicaciones.svelte",
      "filepath": "/ubicaciones.svelte",
      "name": "ubicaciones",
      "ext": "svelte",
      "badExt": false,
      "absolutePath": "/Users/osanchez/Documents/UnigoApp/src/pages/ubicaciones.svelte",
      "importPath": "../../../../src/pages/ubicaciones.svelte",
      "isLayout": false,
      "isReset": false,
      "isIndex": false,
      "isFallback": false,
      "isPage": true,
      "ownMeta": {},
      "meta": {
        "preload": false,
        "prerender": true,
        "precache-order": false,
        "precache-proximity": true,
        "recursive": true
      },
      "path": "/ubicaciones",
      "id": "_ubicaciones",
      "component": () => _ubicaciones
    }
  ],
  "isLayout": false,
  "isReset": false,
  "isIndex": false,
  "isFallback": false,
  "meta": {
    "preload": false,
    "prerender": true,
    "precache-order": false,
    "precache-proximity": true,
    "recursive": true
  },
  "path": "/"
}


export const {tree, routes} = buildClientTree(_tree)

